import { useState } from "react";

export const PermissionsUseBetween = () => {
  const [claims, setClaims] = useState<string[]>();
  return {
    claims,
    setClaims,
  }
}